import React from 'react';
import formatter from '../../utils/formatter';
import { renderCardText } from '../../utils/manaSymbols';

// Cards saved before the typeLine column existed only have the comma-joined
// `types` string, which lost the em-dash. Show that rather than nothing until the
// backfill (npm run backfill:card-text) or the per-card self-heal fills it in.
const buildTypeLine = commander =>
  commander.typeLine ||
  (commander.types ? commander.types.split(',').join(' ') : '');

const CommanderDetails = ({ commander, cardKingdomPrice }) => {
  const typeLine = buildTypeLine(commander);
  const oracleParagraphs = commander.oracleText
    ? commander.oracleText.split('\n').filter(line => line.trim())
    : [];

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex flex-row flex-wrap items-center gap-x-2">
        <h3 className="text-lg font-semibold">{commander.name}</h3>
        {commander.manaCost && (
          <span className="flex flex-row gap-x-0.5">
            {renderCardText(commander.manaCost)}
          </span>
        )}
      </div>

      {typeLine && <p className="text-sm text-gray-400">{typeLine}</p>}

      {oracleParagraphs.length > 0 && (
        <div className="flex flex-col gap-y-1 text-sm">
          {oracleParagraphs.map((paragraph, index) => (
            <p key={index}>{renderCardText(paragraph)}</p>
          ))}
        </div>
      )}

      <p className="text-sm">
        <i className="fas fa-tag mr-2"></i>
        {cardKingdomPrice
          ? `Precio del comandante (CK): ${formatter.formatNumber(
              cardKingdomPrice,
            )} USD`
          : 'Sin precio de referencia de CardKingdom'}
      </p>
    </div>
  );
};

export default CommanderDetails;
